export const POE_THRESHOLD_PERCENT = 80;

export const RSSI_CATEGORIES = [
  "< -80 dBm",
  "-80 dBm ~ -60 dBm",
  "> -60 dBm",
];

export const CHART_GRID_DEFAULT = {
  top: 25,
  bottom: 30,
  left: 20,
  right: 20,
  containLabel: true,
};

export const CHART_TOOLTIP_STYLE = "box-shadow: 0px 2px 8px rgba(0,0,0,0.08); border-radius: 6px;";
